import { getVehicleEquipment } from '../../server/api/mappers/vehicles.helpers';

/**
 * MINI Cooper
 *
 * ```
 *     State:   For Sale
 *    Images:   Yes
 *      Bids:   3
 * User bids:   0
 *    Mapper:   No
 * ```
 */
export default () => {
	const vehicle = {
		additionalDetails: 'additional info',
		additionalSpec: 'Chilli pack, DAB Radio. Minimum. Bluetooth. Minimum 4mm tyre tread.',
		availableFrom: '2016-02-04T00:00:00.000Z',
		availableUntil: '2016-03-01T00:00:00.000Z',
		bids: {
			activeBidCount: 3,
			userBids: [],
		},
		dentsDesc: 'some dents',
		displayPrice: 8430,
		equipment: 'sound_system,parking_cam,panoramic_roof,heated_seats,sat_nav',
		exteriorGrade: 'silver',
		hasAdditionalDamage: true,
		hasBeenSmokedIn: undefined,
		hasDents: true,
		hasLockingWheelNut: true,
		hasMissingParts: true,
		hasOtherContactActiveBid: false,
		hasPaintProblems: true,
		hasPrivatePlate: true,
		hasScratches: true,
		hasScuffedAlloy: true,
		hasServiceRecords: true,
		hasToolsInBoot: true,
		hasWarningLights: true,
		hasWindscreenProblems: true,
		highestBid: 1200,
		id: 49315,
		independentServiceStampsCount: 1,
		interiorType: 'Half leather',
		isTrade: false,
		isVatQualifying: null,
		isVehicleOnFinance: true,
		keepersList: [{ startDate: '2011-03-31' }, { startDate: '2012-01-18' }],
		keeperStartDate: '2015-02-23T00:00:00.000Z',
		keysCount: 2,
		lastMOTDate: '2018-10-29T00:00:00.000Z',
		mileage: 39000,
		mileageRecords: [
			{
				isSuspicious: false,
				mileage: 7960,
				recordTaken: '2023-03-24T11:38:48.001',
				source: 'MOT',
			},
			{
				isSuspicious: false,
				mileage: 4694,
				recordTaken: '2022-04-09T23:59:00',
				source: `RMI MIL'GE`,
			},
			{
				isSuspicious: true,
				mileage: 1644,
				recordTaken: '2021-04-01T23:59:00',
				source: `RMI MIL'GE`,
			},
		],
		minimumBid: {
			type: 'offer',
			value: 1000,
		},
		missingPartsDesc: 'some missing lights',
		officialServiceStampsCount: 2,
		paintProblemsDesc: 'some paintwork',
		prettyVrm: 'FD64 LBX',
		previousKeepersCount: 1,
		priceAverageCondition: 10700,
		priceGoodCondition: 11350,
		priceRetail: 12950,
		scratchesDesc: '      some scratches 123    ',
		scuffedAlloyDesc: 'some scuffed alloys',
		seller: {
			area: 'Greater London',
			country: null,
			distance: 123,
			town: 'London',
		},
		sellerWillAcceptPrice: 8430,
		serviceHistory: 'yes',
		soldDate: '2019-03-08T17:17:47.592Z',
		spec: {
			body: 'Saloon',
			colour: 'Grey',
			engineSize: 1499,
			firstRegistered: '2014-12-03T00:00:00.000Z',
			fuel: 'Petrol',
			make: 'MINI',
			model: 'Cooper Auto',
			transmission: 'Automatic',
			vin: 'WMWXS520602B37306',
		},
		state: {
			category: 'for_sale',
			id: 1,
			name: 'For Sale',
			slug: 'for_sale',
		},
		tyreProblemsDesc: 'some tyre problems',
		vehicleImages: [
			{
				enquiryId: 49315,
				id: 168051,
				kind: 'exterior_front_driver',
				meta: {
					height: '900',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1200',
					x: '0',
					y: '190',
				},
				url: 'https://motorway.imgix.net/9315/49315/exterior_front_driver-1551280095715.jpg',
			},
			{
				enquiryId: 49315,
				id: 168052,
				kind: 'exterior_rear_driver',
				meta: {
					height: '900',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1200',
					x: '0',
					y: '176',
				},
				url: 'https://motorway.imgix.net/9315/49315/exterior_rear_driver-1551280097470.jpg',
			},
			{
				enquiryId: 49315,
				id: 168045,
				kind: 'exterior_front_passenger',
				meta: {
					height: '576',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '768',
					x: '0',
					y: '116',
				},
				url: 'https://motorway.imgix.net/9315/49315/exterior_front_passenger-1551279962576.jpg',
			},
			{
				enquiryId: 49315,
				id: 168046,
				kind: 'exterior_rear_passenger',
				meta: {
					height: '576',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '768',
					x: '0',
					y: '82',
				},
				url: 'https://motorway.imgix.net/9315/49315/exterior_rear_passenger-1551279963928.jpg',
			},
			{
				enquiryId: 49315,
				id: 168053,
				kind: 'interior_front_seats',
				meta: {
					height: '996',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1328',
					x: '0',
					y: '14',
				},
				url: 'https://motorway.imgix.net/9315/49315/interior_front_seats-1551280137198.jpg',
			},
			{
				enquiryId: 49315,
				id: 168055,
				kind: 'interior_rear_seats',
				meta: {
					height: '996',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1328',
					x: '0',
					y: '14',
				},
				url: 'https://motorway.imgix.net/9315/49315/interior_rear_seats-1551280139838.jpg',
			},
			{
				enquiryId: 49315,
				id: 168054,
				kind: 'interior_dashboard',
				meta: {
					height: '996',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1328',
					x: '0',
					y: '14',
				},
				url: 'https://motorway.imgix.net/9315/49315/interior_dashboard-1551280138444.jpg',
			},
			{
				enquiryId: 49315,
				id: 168047,
				kind: 'wheels_front_driver',
				meta: {
					height: '691',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '922',
					x: '0',
					y: '26',
				},
				url: 'https://motorway.imgix.net/9315/49315/wheels_front_driver-1551280078572.jpg',
			},
			{
				enquiryId: 49315,
				id: 168048,
				kind: 'wheels_rear_driver',
				meta: {
					height: '691',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '922',
					x: '0',
					y: '3',
				},
				url: 'https://motorway.imgix.net/9315/49315/wheels_rear_driver-1551280080613.jpg',
			},
			{
				enquiryId: 49315,
				id: 168049,
				kind: 'wheels_front_passenger',
				meta: {
					height: '829',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1106',
					x: '0',
					y: '85',
				},
				url: 'https://motorway.imgix.net/9315/49315/wheels_front_passenger-1551280083045.jpg',
			},
			{
				enquiryId: 49315,
				id: 168050,
				kind: 'wheels_rear_passenger',
				meta: {
					height: '691',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '922',
					x: '0',
					y: '5',
				},
				url: 'https://motorway.imgix.net/9315/49315/wheels_rear_passenger-1551280084533.jpg',
			},
			{
				enquiryId: 49315,
				id: 168012,
				kind: 'tyre_tread_front_driver',
				meta: {
					height: '576',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '768',
					x: '0',
					y: '6',
				},
				url: 'https://motorway.imgix.net/9315/49315/tyre_tread_front_driver-1551279320543.jpg',
			},
			{
				enquiryId: 49315,
				id: 168013,
				kind: 'tyre_tread_rear_driver',
				meta: {
					height: '996',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1328',
					x: '0',
					y: '14',
				},
				url: 'https://motorway.imgix.net/9315/49315/tyre_tread_rear_driver-1551279321802.jpg',
			},
			{
				enquiryId: 49315,
				id: 168014,
				kind: 'tyre_tread_front_passenger',
				meta: {
					height: '576',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '768',
					x: '0',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9315/49315/tyre_tread_front_passenger-1551279323099.jpg',
			},
			{
				enquiryId: 49315,
				id: 168015,
				kind: 'tyre_tread_rear_passenger',
				meta: {
					height: '576',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '768',
					x: '0',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9315/49315/tyre_tread_rear_passenger-1551279324801.jpg',
			},
			{
				enquiryId: 49281,
				id: 168968,
				kind: 'damage_scratches',
				meta: {
					height: '183',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '244',
					x: '16',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_scratches-0-1551376981636.jpg',
			},
			{
				enquiryId: 49281,
				id: 168969,
				kind: 'damage_scratches',
				meta: {
					height: '183',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '244',
					x: '16',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_scratches-1-1551376985709.jpg',
			},
			{
				enquiryId: 49281,
				id: 168970,
				kind: 'damage_scratches',
				meta: {
					height: '184',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '245',
					x: '15',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_scratches-2-1551376988367.jpg',
			},
			{
				enquiryId: 49315,
				id: 168005,
				kind: 'damage_scuffs',
				meta: {
					height: '996',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1328',
					x: '0',
					y: '14',
				},
				url: 'https://motorway.imgix.net/9315/49315/damage_scuffs-0-1551279282963.jpg',
			},
			{
				enquiryId: 49315,
				id: 168006,
				kind: 'damage_scuffs',
				meta: {
					height: '576',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '768',
					x: '0',
					y: '89',
				},
				url: 'https://motorway.imgix.net/9315/49315/damage_scuffs-1-1551279285209.jpg',
			},
			{
				enquiryId: 49315,
				id: 168007,
				kind: 'damage_scuffs',
				meta: {
					height: '768',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1024',
					x: '0',
					y: '5',
				},
				url: 'https://motorway.imgix.net/9315/49315/damage_scuffs-2-1551279286936.jpg',
			},
			{
				enquiryId: 49315,
				id: 168008,
				kind: 'damage_scuffs',
				meta: {
					height: '995',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '1328',
					x: '0',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9315/49315/damage_scuffs-3-1551279288593.jpg',
			},
			{
				enquiryId: 49315,
				id: 168009,
				kind: 'damage_scuffs',
				meta: {
					height: '691',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '922',
					x: '0',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9315/49315/damage_scuffs-4-1551279291313.jpg',
			},
			{
				enquiryId: 49315,
				id: 168010,
				kind: 'damage_scuffs',
				meta: {
					height: '691',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '922',
					x: '0',
					y: '6',
				},
				url: 'https://motorway.imgix.net/9315/49315/damage_scuffs-5-1551279292690.jpg',
			},
			{
				enquiryId: 49281,
				id: 168973,
				kind: 'damage_dents',
				meta: {
					height: '187',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '249',
					x: '10',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_dents-0-1551377021501.jpg',
			},
			{
				enquiryId: 49281,
				id: 168974,
				kind: 'damage_dents',
				meta: {
					height: '168',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '224',
					x: '38',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_dents-1-1551377025198.jpg',
			},
			{
				enquiryId: 49281,
				id: 168975,
				kind: 'damage_paintwork',
				meta: {
					height: '168',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '224',
					x: '38',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_paintwork-0-1551377037911.jpg',
			},
			{
				enquiryId: 49281,
				id: 168976,
				kind: 'damage_paintwork',
				meta: {
					height: '168',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '224',
					x: '38',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_paintwork-1-1551377041603.jpg',
			},
			{
				enquiryId: 49281,
				id: 168977,
				kind: 'damage_missing_trims',
				meta: {
					height: '168',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '224',
					x: '38',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_missing_trims-0-1551377061245.jpg',
			},
			{
				enquiryId: 49281,
				id: 168978,
				kind: 'damage_missing_trims',
				meta: {
					height: '193',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '257',
					x: '2',
					y: '0',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_missing_trims-1-1551377064375.jpg',
			},
			{
				enquiryId: 49281,
				id: 168979,
				kind: 'damage_alloy_scuffs',
				meta: {
					height: '169',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '225',
					x: '0',
					y: '28',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_alloy_scuffs-0-1551377138538.jpg',
			},
			{
				enquiryId: 49281,
				id: 168980,
				kind: 'damage_alloy_scuffs',
				meta: {
					height: '169',
					rotate: '0',
					scaleX: '1',
					scaleY: '1',
					width: '225',
					x: '0',
					y: '28',
				},
				url: 'https://motorway.imgix.net/9281/49281/damage_alloy_scuffs-1-1551377141542.jpg',
			},
		],
		vrm: 'FD64LBX',
		warningLightsDesc: 'some warning lights',
		windscreenProblemsDesc: 'some desc',
		year: 2014,
	};

	return {
		...vehicle,
		equipmentV2: getVehicleEquipment(vehicle),
	};
};
